import React from 'react';
import Layout from '../components/Layout/Layout';

const Terms = () => {
  return (
    <Layout
      title="Terms of Service | Prix du Canada"
      description="Terms of service for Prix du Canada ballet competition - rules, conditions, and guidelines for participation."
      keywords="terms of service, competition rules, prix du canada terms"
    >
      <section className="section" style={{background: 'var(--warm-white)', paddingTop: '4rem', paddingBottom: '4rem'}}>
        <div className="container">
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            <h1 style={{
              fontFamily: "'Playfair Display', 'Georgia', serif",
              fontSize: '2.5rem',
              marginBottom: '1rem',
              color: 'var(--charcoal)'
            }}>
              Terms of Service
            </h1>

            <p style={{ color: 'var(--soft-gray)', marginBottom: '2rem' }}>
              <strong>Last Updated:</strong> December 2025
            </p>

            <div style={{ lineHeight: 1.8, color: 'var(--charcoal)' }}>

              <h2 style={{
                fontFamily: "'Playfair Display', 'Georgia', serif",
                fontSize: '1.8rem',
                marginTop: '2rem',
                marginBottom: '1rem',
                color: 'var(--charcoal)'
              }}>
                1. Acceptance of Terms
              </h2>
              <p>
                Welcome to Prix du Canada. By accessing and using our website (prixducanada.com), registering for our competition, or participating in our events, you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our services.
              </p>

              <h2 style={{
                fontFamily: "'Playfair Display', 'Georgia', serif",
                fontSize: '1.8rem',
                marginTop: '2rem',
                marginBottom: '1rem',
                color: 'var(--charcoal)'
              }}>
                2. About Prix du Canada
              </h2>
              <p>
                Prix du Canada is a ballet competition dedicated to celebrating artistry, diversity, and excellence in classical ballet. We provide a platform for dancers of all backgrounds to showcase their talent and pursue professional opportunities.
              </p>

              <h2 style={{
                fontFamily: "'Playfair Display', 'Georgia', serif",
                fontSize: '1.8rem',
                marginTop: '2rem',
                marginBottom: '1rem',
                color: 'var(--charcoal)'
              }}>
                3. User Accounts
              </h2>

              <h3 style={{
                fontSize: '1.3rem',
                marginTop: '1.5rem',
                marginBottom: '0.75rem',
                color: 'var(--charcoal)'
              }}>
                3.1 Account Registration
              </h3>
              <p>
                To register for the competition, you must create an account. You may register using email/password or through Google Sign-In. You agree to:
              </p>
              <ul style={{ marginLeft: '2rem', marginBottom: '1rem', textAlign: 'left' }}>
                <li>Provide accurate, current, and complete information</li>
                <li>Maintain and update your information to keep it accurate</li>
                <li>Maintain the security of your account credentials</li>
                <li>Notify us immediately of any unauthorized access or security breach</li>
                <li>Accept responsibility for all activities under your account</li>
              </ul>

              <h3 style={{
                fontSize: '1.3rem',
                marginTop: '1.5rem',
                marginBottom: '0.75rem',
                color: 'var(--charcoal)'
              }}>
                3.2 Age Requirements
              </h3>
              <p>
                Our competition is open to dancers of various ages. Participants under 18 must have parental or guardian consent to register and participate. By registering a minor, you confirm that you are the parent or legal guardian and have authority to consent on their behalf.
              </p>

              <h2 style={{
                fontFamily: "'Playfair Display', 'Georgia', serif",
                fontSize: '1.8rem',
                marginTop: '2rem',
                marginBottom: '1rem',
                color: 'var(--charcoal)'
              }}>
                4. Competition Registration
              </h2>

              <h3 style={{
                fontSize: '1.3rem',
                marginTop: '1.5rem',
                marginBottom: '0.75rem',
                color: 'var(--charcoal)'
              }}>
                4.1 Registration Process
              </h3>
              <p>
                Registration for Prix du Canada requires:
              </p>
              <ul style={{ marginLeft: '2rem', marginBottom: '1rem', textAlign: 'left' }}>
                <li>Creating an account</li>
                <li>Completing the registration form with accurate information</li>
                <li>Selecting appropriate age divisions and categories</li>
                <li>Paying the required registration fees</li>
                <li>Agreeing to competition rules and guidelines</li>
              </ul>

              <h3 style={{
                fontSize: '1.3rem',
                marginTop: '1.5rem',
                marginBottom: '0.75rem',
                color: 'var(--charcoal)'
              }}>
                4.2 Registration Fees
              </h3>
              <p>
                Registration fees are non-refundable except as outlined in our refund policy. Payment must be completed at the time of registration. We reserve the right to modify fees with reasonable notice.
              </p>

              <h3 style={{
                fontSize: '1.3rem',
                marginTop: '1.5rem',
                marginBottom: '0.75rem',
                color: 'var(--charcoal)'
              }}>
                4.3 Refund Policy
              </h3>
              <p>
                Registration fees may be refunded under the following conditions:
              </p>
              <ul style={{ marginLeft: '2rem', marginBottom: '1rem', textAlign: 'left' }}>
                <li>Cancellation within 72 hours of registration: 100% refund</li>
                <li>Cancellation after 72 hours of registration: No refund</li>
                <li>Competition cancellation by organizers: Full refund</li>
              </ul>

              <h2 style={{
                fontFamily: "'Playfair Display', 'Georgia', serif",
                fontSize: '1.8rem',
                marginTop: '2rem',
                marginBottom: '1rem',
                color: 'var(--charcoal)'
              }}>
                5. Competition Rules
              </h2>

              <h3 style={{
                fontSize: '1.3rem',
                marginTop: '1.5rem',
                marginBottom: '0.75rem',
                color: 'var(--charcoal)'
              }}>
                5.1 Eligibility
              </h3>
              <p>
                Participants must meet age and skill level requirements for their chosen category. False representation of age or experience may result in disqualification without refund.
              </p>

              <h3 style={{
                fontSize: '1.3rem',
                marginTop: '1.5rem',
                marginBottom: '0.75rem',
                color: 'var(--charcoal)'
              }}>
                5.2 Conduct
              </h3>
              <p>
                All participants, teachers, and attendees must:
              </p>
              <ul style={{ marginLeft: '2rem', marginBottom: '1rem', textAlign: 'left' }}>
                <li>Treat all participants, judges, and staff with respect</li>
                <li>Follow all venue rules and regulations</li>
                <li>Arrive on time for scheduled performances</li>
                <li>Dress appropriately in proper dance attire</li>
                <li>Refrain from disruptive or inappropriate behavior</li>
              </ul>
              <p>
                Violations may result in disqualification or removal from the venue without refund.
              </p>

              <h3 style={{
                fontSize: '1.3rem',
                marginTop: '1.5rem',
                marginBottom: '0.75rem',
                color: 'var(--charcoal)'
              }}>
                5.3 Judging
              </h3>
              <p>
                All judging decisions are final. Judges' scores and feedback are provided at their discretion. We do not accept appeals or disputes regarding judging decisions.
              </p>

              <h2 style={{
                fontFamily: "'Playfair Display', 'Georgia', serif",
                fontSize: '1.8rem',
                marginTop: '2rem',
                marginBottom: '1rem',
                color: 'var(--charcoal)'
              }}>
                6. Intellectual Property
              </h2>

              <h3 style={{
                fontSize: '1.3rem',
                marginTop: '1.5rem',
                marginBottom: '0.75rem',
                color: 'var(--charcoal)'
              }}>
                6.1 Website Content
              </h3>
              <p>
                All content on this website, including text, graphics, logos, images, and software, is the property of Prix du Canada or its licensors and is protected by copyright and intellectual property laws.
              </p>

              <h3 style={{
                fontSize: '1.3rem',
                marginTop: '1.5rem',
                marginBottom: '0.75rem',
                color: 'var(--charcoal)'
              }}>
                6.2 Photography and Video
              </h3>
              <p>
                By participating in Prix du Canada, you grant us permission to photograph, film, and record your participation for promotional, educational, and archival purposes. You waive any rights to compensation for such use.
              </p>
              <p>
                If you do not wish to be photographed or filmed, please notify us in writing before the event.
              </p>

              <h2 style={{
                fontFamily: "'Playfair Display', 'Georgia', serif",
                fontSize: '1.8rem',
                marginTop: '2rem',
                marginBottom: '1rem',
                color: 'var(--charcoal)'
              }}>
                7. Liability and Disclaimers
              </h2>

              <h3 style={{
                fontSize: '1.3rem',
                marginTop: '1.5rem',
                marginBottom: '0.75rem',
                color: 'var(--charcoal)'
              }}>
                7.1 Assumption of Risk
              </h3>
              <p>
                Dance is a physical activity that involves risk of injury. By participating, you acknowledge these risks and agree to participate at your own risk. You are responsible for ensuring you are physically fit to participate.
              </p>

              <h3 style={{
                fontSize: '1.3rem',
                marginTop: '1.5rem',
                marginBottom: '0.75rem',
                color: 'var(--charcoal)'
              }}>
                7.2 Limitation of Liability
              </h3>
              <p>
                To the fullest extent permitted by law, Prix du Canada, its organizers, staff, and affiliates shall not be liable for:
              </p>
              <ul style={{ marginLeft: '2rem', marginBottom: '1rem', textAlign: 'left' }}>
                <li>Personal injury or property damage occurring during the event</li>
                <li>Loss or theft of personal belongings</li>
                <li>Cancellation or postponement of the competition due to circumstances beyond our control</li>
                <li>Technical issues with the website or registration system</li>
                <li>Any indirect, incidental, or consequential damages</li>
              </ul>

              <h3 style={{
                fontSize: '1.3rem',
                marginTop: '1.5rem',
                marginBottom: '0.75rem',
                color: 'var(--charcoal)'
              }}>
                7.3 Indemnification
              </h3>
              <p>
                You agree to indemnify and hold harmless Prix du Canada from any claims, damages, or expenses arising from your participation, your breach of these Terms, or your violation of any law or third-party rights.
              </p>

              <h2 style={{
                fontFamily: "'Playfair Display', 'Georgia', serif",
                fontSize: '1.8rem',
                marginTop: '2rem',
                marginBottom: '1rem',
                color: 'var(--charcoal)'
              }}>
                8. Cancellations and Changes
              </h2>
              <p>
                We reserve the right to:
              </p>
              <ul style={{ marginLeft: '2rem', marginBottom: '1rem', textAlign: 'left' }}>
                <li>Cancel, postpone, or reschedule the competition due to unforeseen circumstances</li>
                <li>Modify competition format, categories, or rules with reasonable notice</li>
                <li>Change venue, dates, or times if necessary</li>
                <li>Limit the number of participants</li>
              </ul>
              <p>
                In case of cancellation by organizers, full refunds will be provided. For postponement or rescheduling, participants may request a refund or transfer their registration.
              </p>

              <h2 style={{
                fontFamily: "'Playfair Display', 'Georgia', serif",
                fontSize: '1.8rem',
                marginTop: '2rem',
                marginBottom: '1rem',
                color: 'var(--charcoal)'
              }}>
                9. Privacy and Data Protection
              </h2>
              <p>
                Your use of our services is also governed by our <a href="/privacy" style={{ color: 'var(--primary-gold)' }}>Privacy Policy</a>. Please review it to understand how we collect, use, and protect your personal information.
              </p>

              <h2 style={{
                fontFamily: "'Playfair Display', 'Georgia', serif",
                fontSize: '1.8rem',
                marginTop: '2rem',
                marginBottom: '1rem',
                color: 'var(--charcoal)'
              }}>
                10. Third-Party Services
              </h2>
              <p>
                Our website may contain links to third-party websites or services (including Google Sign-In). We are not responsible for the content, privacy policies, or practices of third-party sites. Your use of third-party services is at your own risk.
              </p>

              <h2 style={{
                fontFamily: "'Playfair Display', 'Georgia', serif",
                fontSize: '1.8rem',
                marginTop: '2rem',
                marginBottom: '1rem',
                color: 'var(--charcoal)'
              }}>
                11. Prohibited Activities
              </h2>
              <p>
                You agree not to:
              </p>
              <ul style={{ marginLeft: '2rem', marginBottom: '1rem', textAlign: 'left' }}>
                <li>Use our services for any illegal purpose</li>
                <li>Provide false or misleading information</li>
                <li>Impersonate another person or entity</li>
                <li>Interfere with or disrupt our services</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Use automated systems to access our website</li>
                <li>Reproduce, modify, or distribute our content without permission</li>
                <li>Harass, threaten, or harm other users</li>
              </ul>

              <h2 style={{
                fontFamily: "'Playfair Display', 'Georgia', serif",
                fontSize: '1.8rem',
                marginTop: '2rem',
                marginBottom: '1rem',
                color: 'var(--charcoal)'
              }}>
                12. Termination
              </h2>
              <p>
                We reserve the right to suspend or terminate your account and access to our services at any time, with or without notice, for any reason, including violation of these Terms. Upon termination, your right to use our services will immediately cease.
              </p>

              <h2 style={{
                fontFamily: "'Playfair Display', 'Georgia', serif",
                fontSize: '1.8rem',
                marginTop: '2rem',
                marginBottom: '1rem',
                color: 'var(--charcoal)'
              }}>
                13. Modifications to Terms
              </h2>
              <p>
                We may modify these Terms at any time. We will notify you of significant changes by posting a notice on our website or sending an email. Your continued use of our services after changes constitutes acceptance of the modified Terms.
              </p>

              <h2 style={{
                fontFamily: "'Playfair Display', 'Georgia', serif",
                fontSize: '1.8rem',
                marginTop: '2rem',
                marginBottom: '1rem',
                color: 'var(--charcoal)'
              }}>
                14. Governing Law
              </h2>
              <p>
                These Terms are governed by the laws of the Province of Ontario and the federal laws of Canada applicable therein, without regard to conflict of law principles. Any disputes shall be resolved in the courts of Ontario.
              </p>

              <h2 style={{
                fontFamily: "'Playfair Display', 'Georgia', serif",
                fontSize: '1.8rem',
                marginTop: '2rem',
                marginBottom: '1rem',
                color: 'var(--charcoal)'
              }}>
                15. Severability
              </h2>
              <p>
                If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions shall remain in full force and effect.
              </p>

              <h2 style={{
                fontFamily: "'Playfair Display', 'Georgia', serif",
                fontSize: '1.8rem',
                marginTop: '2rem',
                marginBottom: '1rem',
                color: 'var(--charcoal)'
              }}>
                16. Contact Information
              </h2>
              <p>
                For questions about these Terms of Service, please contact us:
              </p>
              <ul style={{ marginLeft: '2rem', marginBottom: '1rem', listStyle: 'none', textAlign: 'left' }}>
                <li><strong>Email:</strong> <a href="mailto:info@prixducanada.com" style={{ color: 'var(--primary-gold)' }}>info@prixducanada.com</a></li>
                <li><strong>Website:</strong> <a href="https://prixducanada.com" style={{ color: 'var(--primary-gold)' }}>prixducanada.com</a></li>
              </ul>

              <div style={{
                marginTop: '3rem',
                padding: '1.5rem',
                background: 'var(--soft-cream)',
                borderLeft: '4px solid var(--primary-gold)',
                borderRadius: '4px'
              }}>
                <p style={{ margin: 0, fontSize: '0.95rem' }}>
                  <strong>By registering for Prix du Canada or using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.</strong>
                </p>
              </div>

            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Terms;
